import React, {Fragment, useContext, useEffect, useState} from 'react';

import {Form, FormGroup} from 'reactstrap';

import {useForm} from "react-hook-form";

import {Btn} from "../../../../../AbstractElements";
import TextInput from "../../../../../CommonElements/Input/TextInput";
import Loader from "../../../../../Layout/Loader";
import axiosConfig from "../../../../../Config/axios";
import BackendDropDown from "../../../../../CommonElements/DropDown/BackendDropDown";
import AuthorizationContext from "../../../../../_helper/Authorization";
import {Participant, ParticipantFormValues} from "../../Types/ParticipantTypes";
import type {AuthorizationContextType} from "../../../../../_helper/Authorization/AuthorizationTypes";

const ParticipantForm = ({callBack, participant}: { callBack?: (participant: Participant) => void; participant?: Participant }) => {
    const [loaderVisibility, setLoaderVisibility] = useState(false);
    const authContext = useContext(AuthorizationContext) as AuthorizationContextType;
    const {errorHandler} = authContext || {};

    const {
        register, handleSubmit, setError, clearErrors, formState: {errors}, setValue, getValues
    } = useForm<ParticipantFormValues>();

    useEffect(() => {
        if (participant) {
            setValue('user_id', participant.user?.id);
            if (participant.collector?.id) {
                setValue('collector_id', participant.collector.id);
            }
        }
    }, [participant])

    const onSubmit = (data: ParticipantFormValues) => {
        clearErrors();
        setLoaderVisibility(true);
        participant ? updateParticipant(data) : createParticipant(data);
    }

    const createParticipant = (data: ParticipantFormValues) => {
        clearErrors();
        setLoaderVisibility(true);
        axiosConfig
            .post(`/application/participant`, data)
            .then((response: { data: { data: any; }; }) => {
                if (response?.data?.data) {
                    callBack && callBack(response?.data?.data);
                }
                setLoaderVisibility(false);
            })
            .catch((exception: any) => {
                errorHandler(exception, setError);
                setLoaderVisibility(false);
            });
    }

    const updateParticipant = (data: ParticipantFormValues) => {
        if (!participant) return;
        clearErrors();
        setLoaderVisibility(true);
        axiosConfig
            .put(`/application/participant/${participant.id}`, data)
            .then((response: { data: { data: any; }; }) => {
                if (response?.data?.data) {
                    callBack && callBack(response?.data?.data);
                }
                setLoaderVisibility(false);
            })
            .catch((exception: any) => {
                errorHandler(exception, setError);
                setLoaderVisibility(false);
            });
    }
    return (<Fragment>
        <Form onSubmit={handleSubmit(onSubmit)}>
            <Loader visibility={loaderVisibility}/>
            <BackendDropDown name={'collector_id'} label={'Collector'} nameColumn={'name'}
                             getValues={getValues}
                             register={register}
                             errors={errors} url={'application/collector'} options={{required: true}}/>
            <TextInput name={'name'} type={'text'} label={'Name'} register={register}
                       errors={errors} placeholder={'Participant Name'} options={{required: true}}/>
            <TextInput name={'contact_number'} type={'text'} label={'Contact Number'} register={register}
                       errors={errors} placeholder={'Contact Number'} options={{required: true}}/>
            <FormGroup>
                <Btn attrBtn={{
                    className: 'd-block w-100 mt-4',
                    color: 'primary',
                    type: 'submit'
                }}>{participant ? 'Update' : 'Create'}</Btn>
            </FormGroup>
        </Form>
    </Fragment>);
};

export default ParticipantForm;